import { QUALITY_PAGE_ACTION, COMMON_CONTENT_ACTION, QUALITY_PAGE_LOADER } from "../type"
 
const initialState ={
    loader : false,
    data :{},
    common_data :{}
}
 
const QualityPrintsReducer  = (state = initialState, action) => {
    switch (action.type){
        case QUALITY_PAGE_LOADER:{
            return {...state,loader : action.loader};
        }
        case QUALITY_PAGE_ACTION :{
            return {...state, data: action.data};
        }
        case COMMON_CONTENT_ACTION :{
             return {...state, common_data: action.data};
        }
        default :{
            return state
        }
    }
}
 
export default QualityPrintsReducer;